import { render, staticRenderFns } from "./ThankYouForSubscribing.vue?vue&type=template&id=205fbb04"
import script from "./ThankYouForSubscribing.vue?vue&type=script&lang=ts"
export * from "./ThankYouForSubscribing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports